window.addEventListener("load", () => {
  // ACCORDION
  const triggers = document.querySelectorAll(".global-accordion-trigger");
  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const targetId = trigger.getAttribute("data-target");
      const content = document.getElementById(targetId);
      const icon = trigger.querySelector(".global-accordion-icon");
      const isOpening = content.classList.contains("hidden");
      const getClasses = (type) => {
        const bg = trigger.dataset[`${type}Bg`];
        const txt = trigger.dataset[`${type}Text`];
        const borders = trigger.dataset[`${type}Border`].split(" ");
        return [bg, txt, ...borders];
      };
      const openClasses = getClasses("open");
      const closedClasses = getClasses("closed");
      content.classList.toggle("hidden");
      if (isOpening) {
        trigger.classList.remove(...closedClasses);
        trigger.classList.add(...openClasses);
        icon.src = icon.dataset.openSrc;
      } else {
        trigger.classList.remove(...openClasses);
        trigger.classList.add(...closedClasses);
        icon.src = icon.dataset.closedSrc;
      }
    });
  });

  // VIDEO PLAYER
  const videoPlaceholders = document.querySelectorAll(
    ".global-video-placeholder",
  );

  videoPlaceholders.forEach((placeholder) => {
    placeholder.addEventListener("click", () => {
      const container = placeholder.closest(".global-video-container");
      const target = container.querySelector(".global-video-player-target");
      const template = container.querySelector(".global-video-embed-code");

      if (!template) return;

      let embedHtml = template.innerHTML;
      if (embedHtml.includes("youtube.com")) {
        embedHtml = embedHtml.replace(
          "feature=oembed",
          "feature=oembed&autoplay=1",
        );
      } else if (embedHtml.includes("vimeo.com")) {
        embedHtml = embedHtml.replace("?", "?autoplay=1&");
      }

      target.innerHTML = embedHtml;
      const iframe = target.querySelector("iframe");
      if (iframe) {
        iframe.classList.add("w-full", "h-full", "absolute", "inset-0");
      }

      placeholder.classList.add("hidden");
      target.classList.remove("hidden");
    });
  });

  // VIDEO MODAL
  const modalOverlay = document.getElementById("global-video-modal-overlay");
  const modalContent = document.getElementById("global-video-modal-content");
  const modalVideoPlayer = document.getElementById("global-video-player");
  const modalVideoThumb = document.getElementById("global-videoThumbnail");
  const closeBtn = document.getElementById("global-close-video-modal-bottom");
  if (!closeBtn) return;

  const modalTriggers = document.querySelectorAll(
    ".global-video-container-trigger",
  );

  function openModal(embedHtml) {
    let finalEmbed = embedHtml;
    if (finalEmbed.includes("youtube.com")) {
      if (finalEmbed.includes("?")) {
        finalEmbed = finalEmbed.replace("?", "?autoplay=1&rel=0&");
      } else {
        finalEmbed = finalEmbed.replace('src="', 'src="?autoplay=1&rel=0&');
      }
    } else if (finalEmbed.includes("vimeo.com")) {
      finalEmbed = finalEmbed.replace("?", "?autoplay=1&");
    }

    modalVideoPlayer.innerHTML = finalEmbed;
    const iframe = modalVideoPlayer.querySelector("iframe");
    if (iframe) {
      iframe.setAttribute("allow", "autoplay; fullscreen");
      iframe.classList.add("w-full", "h-full", "absolute", "inset-0");
    }

    modalVideoThumb.style.opacity = "0";
    modalVideoThumb.style.pointerEvents = "none";
    modalVideoPlayer.style.opacity = "1";
    modalVideoPlayer.style.pointerEvents = "auto";

    modalOverlay.classList.remove("hidden", "pointer-events-none");
    modalOverlay.style.display = "flex";

    setTimeout(() => {
      modalOverlay.classList.add("opacity-100");
      modalContent.classList.remove("scale-95");
      modalContent.classList.add("scale-100");
    }, 10);

    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    modalOverlay.classList.remove("opacity-100");
    modalContent.classList.add("scale-95");
    modalContent.classList.remove("scale-100");

    setTimeout(() => {
      modalOverlay.classList.add("hidden", "pointer-events-none");
      modalOverlay.style.display = "none";

      modalVideoPlayer.innerHTML = "";
      modalVideoPlayer.style.opacity = "0";
      modalVideoPlayer.style.pointerEvents = "none";

      modalVideoThumb.style.opacity = "1";
      modalVideoThumb.style.pointerEvents = "auto";

      document.body.style.overflow = "";
    }, 300);
  }

  modalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const embed = trigger.getAttribute("data-video-embed");
      openModal(embed);
    });
  });

  closeBtn.addEventListener("click", closeModal);
  modalOverlay.addEventListener("click", (e) => {
    if (e.target === modalOverlay) closeModal();
  });
});


	// breadcrumb shift to top 
	const observer = new MutationObserver(() => {
		const main = document.querySelector("main");
		const breadcrumb = document.querySelector(".asb-breadcrumb-wrapper");

		if (main && breadcrumb && main.firstElementChild !== breadcrumb) {
			main.prepend(breadcrumb);
		}
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
